import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = () => {
    const { contentLinks, topLinksLeft, topLinksRight } = useSelector((state) => state.navigation);
    const topLinks = [...topLinksLeft, ...topLinksRight]
    return <NavigationItem links={contentLinks} topLinks={topLinks} />;
};

export default Navigation;
